/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { HTMLAttributes, Children } from 'preact/compat';
import { classes } from '@adobe-commerce/elsie/lib';

import '@adobe-commerce/elsie/components/CartList/CartList.css';

export interface CartListProps extends HTMLAttributes<HTMLDivElement> {}

export const CartList: FunctionComponent<CartListProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div {...props} className={classes(['dropin-cart-list', className])}>
      <div
        className="dropin-cart-list__wrapper"
        aria-live="assertive"
        aria-relevant="all"
      >
        {Children.map(children, (child, key) => {
          return (
            <div key={key} className="dropin-cart-list__item">
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
};
